<template>
  <transition name="fade" mode="out-in">
    <div class="screen-wrap">
      <v-app class="hmc-app">
        <v-main class="main-body">
          <ApiErrorDialog v-if="api.isError" :api="api" />
          <v-container class="app-body">
            <div class="pe-2 ps-3 app-title text-h5">
              {{ $t("title.certificates") }}
              <v-spacer></v-spacer>
              <CloseBtn size="40" :callback="exit" />
            </div>
            <div class="px-5">
              <v-alert type="info" border="left" colored-border class="mb-2">
                {{ $t("string.certificateMsg") }}
              </v-alert>
              <v-alert type="info" border="left" colored-border>
                <div class="mb-2">{{ $t("string.certificateMsgHint") }}</div>
                <div>Microsoft Edge: <a href="https://youtu.be/WgZeh1SqV5U?si=xJYMucCGwST-cfmI" target="_blank">{{ $t("string.certificateMsgButton") }}</a></div>
                <div>Google Chrome: <a href="https://youtu.be/s_z4-sfy890?si=6a55xzpeRKPNF3Ah" target="_blank">{{ $t("string.certificateMsgButton") }}</a></div>
                <div>Apple Iphone: <a href="https://youtube.com/shorts/I4niL-P5X90?si=6qZx0vJrV558ZuJG" target="_blank">{{ $t("string.certificateMsgButton") }}</a></div>
                <div>Android Phone: <a href="https://youtu.be/h1ZavQPKsKU?si=fbOmKOry816THNxo" target="_blank">{{ $t("string.certificateMsgButton") }}</a></div>
              </v-alert>
              <v-card flat class="list-card my-3" v-for="eventx in events" :key="eventx.code">

                <v-img max-width="120" class="mx-auto" :src="eventx.imageUrl"></v-img>
                <v-card-text class="ps-4 pa-1">
                  <div class="text-h6">
                    {{ eventx.name }}
                  </div>
                  <div class="">
                    {{ $moment(eventx.timestampStart).format('YYYY-MM-DD') }} ~ {{
                      $moment(eventx.timestampEnd).format('YYYY-MM-DD') }}
                  </div>
                  <div class="mt-3 d-flex justify-space-between align-center flex-wrap">
                    <v-chip v-if="eventx.Finisher.length > 0" color="green" dark small>
                      {{ $t("string.finisher") }}
                    </v-chip>
                    <v-chip v-else small>
                      {{ $t("string.participant") }}
                    </v-chip>
                    <v-btn color="yellow" small class="my-2"
                      :loading="selectedEvent == eventx.code && generatingCertificate"
                      :disabled="(selectedEvent != eventx.code && generatingCertificate) || $moment(eventx.timestampEnd).isBefore($moment().subtract(90, 'days'))"
                      @click="downloadCertificate(eventx)">
                      <v-icon small class="me-1">mdi-download</v-icon> {{ $t("action.download") }}
                    </v-btn>
                  </div>

                </v-card-text>
              </v-card>
              <Empty :condition="events.length < 1 && api.isLoading == false" />
            </div>
          </v-container>
        </v-main>
      </v-app>
    </div>
  </transition>
</template>

<script>
import { mapState } from "vuex";
export default {
  components: {
    CloseBtn: () =>
      import(
        /* webpackChunkName: "component-btn-close" */ "@/components/btns/CloseBtn"
      ),
    ApiErrorDialog: () =>
      import(
        /* webpackChunkName: "component-api-error-dialog" */ "@/components/ApiErrorDialog.vue"
      ),
  },
  computed: mapState({
    settings: (state) => state.settings.data,
    auth: (state) => state.auth.data,
  }),
  props: [
    //
  ],
  data: () => ({
    api: {
      isLoading: false,
      isError: false,
      error: null,
      url: null,
    },
    events: [],
    generatingCertificate: false,
    selectedEvent: null
  }),
  async created() {
    await this.loadCertificates();
  },
  mounted() {
    //
  },
  methods: {
    exit() {
      this.$router.push({
        name: "PageWorldNews",
      });
    },
    async loadCertificates() {
      this.api.url =
        this.$api.servers.event +
        "/api/v1/" +
        this.$_getLocale() +
        "/game/event/certificate/load";
      this.api.callbackReset = () => {
        this.api.isLoading = true;
        this.api.isError = false;
        this.api.error = null;
      };
      this.api.callbackError = (e) => {
        this.api.isLoading = false;
        this.api.isError = true;
        this.api.error = e;
        console.error(e);
      };
      this.api.callbackSuccess = async (resp) => {
        this.api.isLoading = false;
        this.events = resp.Event
        console.log(resp)
      };
      await this.$api.fetch(this.api);
    },
    downloadCertificate(item) {
      this.generatingCertificate = true
      this.selectedEvent = item.code
      const webAppUrl = process.env.VUE_APP_DIGITAL_CERTIFICATE_GOOGLE_SCRIPT_URL;
      const name = encodeURIComponent(this.auth.Student ? this.auth.Student.name : this.auth.User.name);
      const mochiId = encodeURIComponent(this.auth.Player.mochiId);
      const eventCode = encodeURIComponent(item.code);
      const eventName = encodeURIComponent(item.name);
      const seriesName = encodeURIComponent(item.Series.name);
      const isFinisher = encodeURIComponent(item.Finisher.length > 0);
      const folderId = encodeURIComponent(process.env.VUE_APP_DIGITAL_CERTIFICATE_FOLDER_ID);

      // Append the name to URL
      const fullUrl = `${webAppUrl}?name=${name}&mochiId=${mochiId}&eventCode=${eventCode}&eventName=${eventName}&seriesName=${seriesName}&isFinisher=${isFinisher}&folderId=${folderId}`;
      let that = this
      fetch(fullUrl)
        .then((res) => res.json())
        .then((data) => {
          that.generatingCertificate = false
          window.open(data.url, '_blank');
        })
        .catch((err) => {
          that.generatingCertificate = false
          console.error('Error downloading certificate:', err);
        });
    }
  },
};
</script>

<style scoped>
.app-title {
  z-index: 99;
  position: fixed;
  top: 0;
  max-width: 480px !important;
  width: 100%;
  display: flex;
  align-items: center;
  height: 60px;
  box-shadow: 0px 5px 2px rgba(128, 128, 128, 0.5) !important;
  border: #caad87 5px solid;
  margin: auto;
  color: #fff;
  background-color: #f7efe3;
  text-shadow: #cbb18f 3px 0px 0px, #cbb18f 2.83487px 0.981584px 0px,
    #cbb18f 2.35766px 1.85511px 0px, #cbb18f 1.62091px 2.52441px 0px,
    #cbb18f 0.705713px 2.91581px 0px, #cbb18f -0.287171px 2.98622px 0px,
    #cbb18f -1.24844px 2.72789px 0px, #cbb18f -2.07227px 2.16926px 0px,
    #cbb18f -2.66798px 1.37182px 0px, #cbb18f -2.96998px 0.42336px 0px,
    #cbb18f -2.94502px -0.571704px 0px, #cbb18f -2.59586px -1.50383px 0px,
    #cbb18f -1.96093px -2.27041px 0px, #cbb18f -1.11013px -2.78704px 0px,
    #cbb18f -0.137119px -2.99686px 0px, #cbb18f 0.850987px -2.87677px 0px,
    #cbb18f 1.74541px -2.43999px 0px, #cbb18f 2.44769px -1.73459px 0px,
    #cbb18f 2.88051px -0.838247px 0px;
}

.text-stroke-sm {
  color: #fff;
  text-shadow: #8b5629 3px 0px 0px, #8b5629 2.83487px 0.981584px 0px,
    #8b5629 2.35766px 1.85511px 0px, #8b5629 1.62091px 2.52441px 0px,
    #8b5629 0.705713px 2.91581px 0px, #8b5629 -0.287171px 2.98622px 0px,
    #8b5629 -1.24844px 2.72789px 0px, #8b5629 -2.07227px 2.16926px 0px,
    #8b5629 -2.66798px 1.37182px 0px, #8b5629 -2.96998px 0.42336px 0px,
    #8b5629 -2.94502px -0.571704px 0px, #8b5629 -2.59586px -1.50383px 0px,
    #8b5629 -1.96093px -2.27041px 0px, #8b5629 -1.11013px -2.78704px 0px,
    #8b5629 -0.137119px -2.99686px 0px, #8b5629 0.850987px -2.87677px 0px,
    #8b5629 1.74541px -2.43999px 0px, #8b5629 2.44769px -1.73459px 0px,
    #8b5629 2.88051px -0.838247px 0px;
}

.main-body {
  /*background-color: #c7e5e9;*/
  background-color: rgba(214, 132, 49, 0.3);
}

.app-body {
  max-width: 480px;
  min-height: 100%;
  padding: 80px 0 40px 0;
  /* background-color: #f5dfc5; */
}



.list-card {
  padding: 5px;
  color: #785c3a;
  border-radius: 5px;
  border: #ccaf8b 4px solid;
  background-color: #fff9f1;
  overflow-x: hidden !important;
  display: flex;
}
</style>